import {
	API_GET_ALL_CONSENT_REFUSAL_REASON,
	API_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS,
	API_GET_ALL_CONSENT_REFUSAL_REASON_FAIL,
} from '../actions/consentRefusalReason';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
};

const consentRefusalReasons = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_CONSENT_REFUSAL_REASON_FAIL]: (state, action) => {
		errorHandler(
			'Motif de refus de prise en charge',
			ErrorAction.READ,
			action.error
		);
		state.loading = false;
	},
	[API_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default consentRefusalReasons;
